"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _subMonths = _interopRequireDefault(require("date-fns/subMonths"));
var local = _interopRequireWildcard(require("../local"));
var session = _interopRequireWildcard(require("../session"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable babel/camelcase */
const UTMs = {
  utm_source: "",
  utm_medium: "",
  utm_term: "",
  utm_content: "",
  utm_campaign: "",
  mkt_route: "",
  mkt_postback: "",
  mkt_origin: "",
  mkt_form: "",
  mkt_agency: ""
};
const UTM_TMs = {
  utm_tm_source: "",
  utm_tm_medium: "",
  utm_tm_component: "",
  utm_tm_content: "",
  utm_tm_campaign: "",
  utm_tm_version: ""
};
/* eslint-enable babel/camelcase */

function loadURL(query, utms) {
  return Object.fromEntries(Object.keys(utms).map(utm => [utm, query[utm]]).filter(([, val]) => val != null));
}
function loadStorage() {
  return Object.fromEntries(Object.keys(UTMs).map(utm => [utm, local.load(utm)]).filter(([, loaded]) => loaded != null).map(([utm, loaded]) => {
    const parsed = JSON.parse(loaded);
    return [utm, parsed.value];
  }));
}
function clearStorage() {
  return Object.keys(UTMs).forEach(utm => {
    const loaded = local.load(utm);
    if (loaded == null) {
      return;
    }
    const parsed = JSON.parse(loaded);
    if ((0, _isBefore.default)(new Date(parsed.createdAt), (0, _subMonths.default)(new Date(), 1))) {
      local.remove(utm);
    }
  });
}
function saveLocalStorage(utms) {
  Object.entries(utms).forEach(([key, value]) => {
    local.save(key, JSON.stringify({
      value,
      createdAt: new Date()
    }));
  });
}
function saveSessionStorage(utms) {
  Object.entries(utms).forEach(([key, value]) => {
    session.save(key, JSON.stringify(value));
  });
}

/**
 * @deprecated
 * This whole thing is a huge mess of invalid requirements
 */
const handleUTMs = query => {
  clearStorage(); // Removes outdated UTMs

  // This is redundant, but keeping from R.map(String, query);
  const strings = Object.fromEntries(Object.entries(query).map(([key, val]) => [key, String(val)]));
  const utms = loadURL(strings, UTMs);
  const utmTms = loadURL(strings, UTM_TMs);
  const fromStorage = loadStorage();
  saveLocalStorage(utms);
  saveSessionStorage(utmTms);
  return {
    ...fromStorage,
    ...utmTms,
    ...utms
  };
};
var _default = handleUTMs;
exports.default = _default;